import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class DocumentCounterComponent extends Vue {
  @Prop(Number)
  counter!: number

  @Prop(String)
  title!: string

  @Prop(String)
  color!: string

  @Prop(Boolean)
  loading!: boolean
}
